import { EVENT_LIST } from '../domain/event/EventListData';

const EventDetailPage = ({ match }) => {
  const { event } = match.params;

  return EVENT_LIST.find((e) => e.id === event).component;
};

export default EventDetailPage;
